import React from 'react';
import {Link, Stack, Typography} from '@mui/material';
import {useTranslate} from 'hooks/useTranslate';
import {CreateSigningDemoResponse} from 'hooks/useSigningDemo';

interface SigningResponseViewProps {
  response: CreateSigningDemoResponse;
}

export const SigningResponseView = ({response}: SigningResponseViewProps) => {
  const t = useTranslate();

  return (
    <Stack spacing={1}>
      <Typography variant="body2" color="text.secondary">
        {t('demo.signing.response.created')}
      </Typography>
      {response.signerResponse.map((signer) => (
        <Link
          key={signer.signerId}
          href={signer.signingUrl}
          target="_blank"
          rel="noopener noreferrer">
          {signer.fullName || signer.governmentId || signer.signerId}
        </Link>
      ))}
    </Stack>
  );
};
